import React from "react";
import { Link } from "react-router-dom";

//  Style \\
import "../../assets/styles/footer.scss";

// Icons \\
import { BiLogoTelegram } from "react-icons/bi";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer_items">
          <div className="footer_items_content">
            <div className="footer_items_logo">
              <Link to={"/"} className="linkLogo">
                <h2>Meddical</h2>
              </Link>
              <p>
                Leading the Way in Medical <br /> Execellence, Trusted Care.
              </p>
            </div>

            <div className="importantLinks">
              <p>Important Links</p>

              <ul>
                <li>
                  <Link to={"/appointment"} className="Links">
                    Appointment
                  </Link>
                </li>
                <li>
                  <Link to={"/doctors"} className="Links">
                    Doctors
                  </Link>
                </li>
                <li>
                  <Link to={"/services"} className="Links">
                    Services
                  </Link>
                </li>
                <li>
                  <Link to={"/aboutUs"} className="Links">
                    About Us
                  </Link>
                </li>
              </ul>
            </div>

            <div className="contact">
              <p className="title">Contact Us</p>
              <p>Call: (237) 681-812-255</p>
              <p>Email: fildineesoe@gmail.com</p>
              <p>Address: 0123 Some place</p>
              <p>Some country</p>
            </div>

            <div className="Newsletter">
              <p className="title">Newsletter</p>

              <form>
                <span className="span">
                  <input
                    type="text"
                    className="emailInput"
                    placeholder="Enter your email address"
                  />
                  <BiLogoTelegram className="tg" />
                </span>
              </form>
            </div>
          </div>

          <hr className="hr" />

          <div className="end">
            <p>© 2021 Hospital’s name All Rights Reserved by PNTEC-LTD</p>

            <div className="social">
              <a href="" target="_blank">
                <div className="anchor_box">
                  <FaLinkedinIn className="social_icons" />
                </div>
              </a>
              <a href="" target="_blank">
                <div className="anchor_box">
                  <FaFacebookF className="social_icons" />
                </div>
              </a>
              <a href="" target="_blank">
                <div className="anchor_box">
                  <FaInstagram className="social_icons" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
